module.exports = __webpack_public_path__ + "static/img/gywm-KwURyTex.8db2c78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/gywm-KwURyTex.png
// module id = Wfqm
// module chunks = 16